import { throttle } from '../../@helpers/js/queue-processing.js';
import { addEventToDatalayer } from '../../@helpers/js/datalayer.js';

export default function ScrollToTop(element, {
		scrollToTopTargetId = 'content'
	} = {}) {
	if (!element) return;

	const _options = {
		scrollToTopTargetId
	};
	const _s = {
		trigger: `data-scroll-to-target-trigger`,
		triggerContainer: `data-scroll-to-target-container`
	};
	const href = element.getAttribute('href');
	const target = !href.startsWith('#') ? href : `#${_options.scrollToTopTargetId}`;
	const _topTarget = document.querySelector(target) ?? document.getElementsByTagName('body')[0];

	let _topTrigger = document.querySelector(`body > [${_s.trigger}]`);
	let _trigger = _topTrigger;
	if (!_trigger) {
		const _triggers = document.documentElement.querySelectorAll(`[${_s.trigger}]`);
		_trigger = _triggers?.[0];
	}

	if (_trigger !== element) {
		const triggerContainer = element?.closest(`[${_s.triggerContainer}`);
		if (triggerContainer) {
			triggerContainer.parentNode.removeChild(triggerContainer)
		} else {
			element?.parentNode.removeChild(element);
		}
		return;
	}

	let _triggerContainer = _trigger?.closest(`[${_s.triggerContainer}`);
	if (!_triggerContainer) {
		_triggerContainer = document.createElement("nav");
		_triggerContainer.className = 'scroll-to-top__container';
		_triggerContainer.setAttribute(`${_s.triggerContainer}`,'');
		_triggerContainer.setAttribute('inert', true);
		
		_triggerContainer.appendChild(_trigger);
		document.body.appendChild(_triggerContainer);
	}
	
	// Add event listeners for the click on the button and for the window scroll
	_trigger?.addEventListener('click', (e) => {
		const datalayerEvent = {
			event: "event",
			event_category: "button click",
			event_action: "Scroll to top",
			event_name: ''
		}
		addEventToDatalayer(datalayerEvent);
		_topTarget.scrollIntoView();
		e?.preventDefault();
		return false;
	});

	window.addEventListener('scroll', throttle((event) => {
		const clientHeight = (document.documentElement || document.body).clientHeight * 3;

		const scrollPosition = (window.scrollY !== undefined) ? window.scrollY : (document.documentElement || document.body.parentNode || document.body).scrollTop;
		// Check if the user scrolled more than the height of the viewport times 4
		if (scrollPosition > clientHeight) {
			// The user scrolled more than the height of the viewport, we will make the
			// scroll to top button available
			_trigger?.classList.remove('not-available');
			_triggerContainer?.removeAttribute('inert');
		} else {
			// The scroll position of the document is less than the height of the
			// viewport, we will hide the scroll to top button
			_trigger?.classList.add('not-available');
			_triggerContainer?.setAttribute('inert', true);
		}
	}));
};
